import { render, staticRenderFns } from "./AdminVisionClinics.html?vue&type=template&id=4dc13c42&external"
import script from "./AdminVisionClinics.vue?vue&type=script&lang=js"
export * from "./AdminVisionClinics.vue?vue&type=script&lang=js"
import style0 from "./AdminVisionClinics.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports